import { Button } from "@mui/material";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import { useStateValue } from "../StateProvider";

import "./ProductCard.css";
function ProductCard({ brand, description,images, stock,thumbnail,title, id, price,rating }) {
 
  const [state,dispatch] = useStateValue();
  
  useEffect(()=>{
    localStorage.setItem("Cart",JSON.stringify(state.cart))
  },[state.cart])
  const addToBasket = () => {
    dispatch({
      type: "Add_To_Cart",
      item: {
        id: id,
        title: title,
        brand:brand,
        description:description,
        images:images,
        thumbnail:thumbnail,
        rating:rating,
        stock:stock,
        price: price,
      },
    });
  };
  return (
    <div className="productcard" >
        <Link to={`${id}`}>
      <div className="productcard_image">
          
          <img
        
        src={thumbnail}
        alt={title}
       
      />

          
        
   </div>
</Link>   
      <div className="productcard_description">
        <p className="product_title">{title}</p>
        <p>
          {description}
        </p>
        <span>
          <small>₹</small>
          <strong>{price*80}</strong>
        </span>
        <div className="product_button">
          <Button onClick={addToBasket} variant="contained">
            Add To Cart
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
